import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const ItemPreview = () => {
  return (
    <Container className="bg-white shadow-lg rounded" style={{ "padding-top": "5rem" }}>
      <Row className="align-items-center">
        {/* Left Side - Image */}
        <Col md={6} className="p-0 text-center">
          <img
            src="/images/image1.png"
            alt="Yoga Pose"
            className="img-fluid rounded-start w-50 h-50"
            style={{ objectFit: "cover" }}
          />
        </Col>

        {/* Right Side -Info */}
        <Col md={6} className="text-center py-4 signupInputs">

          {/* Title */}
          <h2 className="fw-bold">Holiday Vacation</h2>
        </Col>
      </Row>
      <Row className="align-items-center">
        {/* Left Side - Info */}
        <Col md={6} className="text-center py-4 signupInputs">
          {/* Title */}
          <h2 className="fw-bold">Household Items</h2>
        </Col>

        {/* Right Side - Image */}
        <Col md={6} className="p-0 text-center">
          <img
            src="/images/image3.png"
            alt="Yoga Pose"
            className="img-fluid rounded-start w-1 h-1"
            style={{ objectFit: "cover", height: "500px"}}
          />
        </Col>
      </Row>
      <Row className="align-items-center">
        {/* Left Side - Image */}
        <Col md={6} className="p-0 text-center">
          <img
            src="/images/image4.png"
            alt="Yoga Pose"
            className="img-fluid rounded-start w-30 h-30"
            style={{ objectFit: "cover", height: "450px" }}
          />
        </Col>

        {/* Right Side -Info */}
        <Col md={6} className="text-center py-4 signupInputs">

          {/* Title */}
          <h2 className="fw-bold">A New Iphone</h2>
        </Col>
      </Row>
      <Row className="align-items-center">
        {/* Left Side - Info */}
        <Col md={6} className="text-center py-4 signupInputs">
          {/* Title */}
          <h2 className="fw-bold">Money Bouquet</h2>
        </Col>

        {/* Right Side - Image */}
        <Col md={6} className="p-0 text-center">
          <img
            src="/images/image7.png"
            alt="Yoga Pose"
            className="img-fluid rounded-start w-20 h-20"
            style={{ objectFit: "cover" }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default ItemPreview;
